// Stub Firebase implementation to prevent build crashes
// User needs to add real config
const db = {};
export { db };
export const collection = () => { };
export const query = () => { };
export const where = () => { };
export const onSnapshot = () => () => { };
export const addDoc = () => { };
export const serverTimestamp = () => { };
export const orderBy = () => { };
